import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { NotificationService } from '@optsolservices/ngx-notification';
import { BaseService } from 'src/app/core/services/base.service';
import {
  OiGroupDialogData,
  OiGroupProcessDialogComponent,
} from 'src/app/shared/oi-group-process-dialog/oi-group-process-dialog.component';

@Component({
  selector: 'app-syspro-order-misc-charge-dialog',
  templateUrl: './syspro-order-misc-charge-dialog.component.html',
  styleUrls: ['./syspro-order-misc-charge-dialog.component.scss'],
})
export class SysproOrderMiscChargeDialogComponent implements OnInit {
  form: FormGroup;
  serviceChargeConfig: {
    chargeCode: string;
    chargeDescription: string;
    minimumQuantity: number;
    userPrompt: string;
    calculationType: string;
    defaultValue: number;
    defaultTypeCode: string;
  }[];

  selectedCharge: {
    chargeCode: string;
    chargeDescription: string;
    minimumQuantity: number;
    userPrompt: string;
    calculationType: string;
    defaultValue: number;
    defaultTypeCode: string;
  };

  showQtyInput: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<SysproOrderMiscChargeDialogComponent>,
    private baseService: BaseService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) {
    this.form = fb.group({
      chargeCode: [null, Validators.compose([Validators.required])],
      qty: [null],
      defaultValue: [null],
      defaultTypeCode: [null],
    });
  }

  ngOnInit() {
    this.baseService
      .executeCommand<any[]>(
        'portal_sales_order_header_misc_charge_dialog_config',
        {
          salesOrderNumber: this.data.salesOrderNumber,
        }
      )
      .subscribe((response) => {
        if (response.responseCode === 0) {
          this.serviceChargeConfig = response.data;
        }
      });
  }

  save() {
    const dialogData: OiGroupDialogData = {
      title: 'Adding Misc. Charge To Order In Syspro',
      function: 'portal_oi_group_syspro_order_add_misc_charge',
      postBody: {
        salesOrderNumber: this.data.salesOrderNumber,
        ...this.form.getRawValue(),
      },
    };

    const ref = this.dialog.open(OiGroupProcessDialogComponent, {
      data: dialogData,
      width: '450px',
    });

    ref.afterClosed().subscribe((oiResult) => {
      if (oiResult.responseCode === 0) {
        this.notificationService.success('Misc. Charge Added');
        this.dialogRef.close(true);
      }
    });
  }

  chargeCodeSelected(event: any) {
    this.selectedCharge = this.serviceChargeConfig.find(
      (f) => f.chargeCode === event.value
    );

    // Reset form, set relevant validations, and show the quantity input field.
    this.form.controls['qty'].clearValidators();
    this.form.controls['qty'].setValue(null);

    this.form.controls['defaultValue'].clearValidators();
    this.form.controls['defaultValue'].setValue(null);

    this.showQtyInput = false;

    if (this.selectedCharge.defaultTypeCode) {
      this.form.controls['defaultValue'].setValidators(
        Validators.compose([Validators.required, Validators.min(0)])
      );
      this.form.controls['defaultValue'].setValue(
        this.selectedCharge.defaultValue
      );
      this.form.controls['defaultTypeCode'].setValue(
        this.selectedCharge.defaultTypeCode
      );
      this.showQtyInput = true;
    } else {
      if (this.selectedCharge.calculationType === 'U') {
        this.form.controls['qty'].setValidators(
          Validators.compose([
            Validators.required,
            Validators.min(this.selectedCharge.minimumQuantity),
          ])
        );
        this.showQtyInput = true;
      }
    }

    this.form.controls['qty'].updateValueAndValidity();
    this.form.controls['defaultValue'].updateValueAndValidity();
  }
}

